import { CSSProperties, useState } from "react";
import AgTechCollapsibleContainer from "../../Layout/AgTechCollapsibleContainer";

export type AgTechFormSectionProps = {
    header: string,
    headerContent?: () => React.ReactNode,
    collapsible?: boolean,
    isCollapsed?: boolean,
    maxHeight?: number,
    canOverflow?: boolean,
    classes?: string,
    bodyClasses?: string,
    styles?: CSSProperties
};

export const AgTechFormSection = (props: React.PropsWithChildren<AgTechFormSectionProps>) => {
    let [isSectionCollapsed, setIsSectionCollapsed] = useState<boolean>(props.isCollapsed ?? false);

    let sectionHeaderClass = props.collapsible ? 'agtech-clickable' : '';

    let handleFormSectionHeaderClicked = () => {
        if (props.collapsible) {
            setIsSectionCollapsed(!isSectionCollapsed);
        }
    }

    let sectionStyles = {
        ...props.styles,
        overflow: props.canOverflow ? 'auto' : 'hidden'
    }

    return (
        <div className={`row-based pt-1 overflow-hidden flex ${props.classes ?? ''}`} style={sectionStyles}>
            <div className={`column-based text-sm border-b border-highlight font-semibold pt-2 pb-2 pl-1 pr-2 flex ${sectionHeaderClass}`}  onClick={handleFormSectionHeaderClicked}>
                <div className="mt-half items-center flex">
                    {props.header}
                </div>
                <div className='flexed' />
                { props.headerContent ? props.headerContent() : null }
                { props.collapsible ? <i className={`${isSectionCollapsed ? 'chevron-down' : 'chevron-up'}`} /> : null }
            </div>

            { props.collapsible ? (
                <AgTechCollapsibleContainer isCollapsed={isSectionCollapsed} classes={`agtech-form-section-body column-based container ${props.bodyClasses ?? ''}`}>
                    {props.children}
                </AgTechCollapsibleContainer>
            ) : (
                <div className={`row-based px-1 pt-3 flexed overflow-hidden container ${props.bodyClasses ?? ''}`}>
                    {props.children}
                </div>
            )}
        </div>
    );
}